<template>
    <div class="upgrade-show-intro">
        <div class="small-container">
            <p class="step-title">
                Host your show with Fusebox!
            </p>
            <p class="step-description">
                <i>Easy Hosting</i> was built to deliver what every podcaster needs. The tools and features needed to grow your podcast without over-complicating it.
            </p>
        </div>

        <div class="big-container">
            <hosting-benefits />

            <div class="button-container">
                <base-form-button
                    class="btn"
                    :has-arrow="true"
                    @click.native.prevent="$emit('change-step-next')"
                >
                    Yes! Let’s Migrate to Easy Hosting
                </base-form-button>
            </div>
        </div>
    </div>
</template>
<script>
import HostingBenefits from '@/components/Shows/AddOns/HostingBenefits';

export default {
    components: {
        HostingBenefits,
    },
};
</script>
